import { takeLatest } from 'redux-saga/effects';
import { handleSendWhatsapp } from './sendMessageSaga';
import { handleCreateCampaign } from './campaignSaga';
import { handleCreateTemplate } from './templateSaga';
import { handleVerifyMediaTemplate } from './mediaVerificationSaga';
import { handleLoadTemplates, handleLoadTemplateLibrary } from './loadTemplateSaga';
import { handleFetchWabaIds } from './wabaIdSaga';
import { handleFetchPhones } from './phoneSaga';
import {
  handleFetchCampaigns,
  handleFetchCampaignAnalytics,
  handleCreateCampaignSchedule,
  handleUpdateCampaignSchedule,
  handleCancelCampaign
} from './campaignScheduleSaga';
import { handleGenerateAITemplate } from './generateTemplateSaga';

export default function* whatsappSaga() {
  yield takeLatest('SEND_WHATSAPP', handleSendWhatsapp);
  yield takeLatest('CREATE_CAMPAIGN', handleCreateCampaign);
  yield takeLatest('CREATE_WHATSAPP_TEMPLATE', handleCreateTemplate);
  yield takeLatest('VERIFY_MEDIA_TEMPLATE', handleVerifyMediaTemplate);
  yield takeLatest('LOAD_WHATSAPP_TEMPLATES', handleLoadTemplates);
  yield takeLatest('LOAD_TEMPLATE_LIBRARY', handleLoadTemplateLibrary);
  yield takeLatest('FETCH_WABA_IDS', handleFetchWabaIds);
  yield takeLatest('FETCH_PHONES', handleFetchPhones);
  // Campaign scheduling
  yield takeLatest('FETCH_CAMPAIGNS', handleFetchCampaigns);
  yield takeLatest('FETCH_CAMPAIGN_ANALYTICS', handleFetchCampaignAnalytics);
  yield takeLatest('CREATE_CAMPAIGN_SCHEDULE', handleCreateCampaignSchedule);
  yield takeLatest('UPDATE_CAMPAIGN_SCHEDULE', handleUpdateCampaignSchedule);
  yield takeLatest('CANCEL_CAMPAIGN_SCHEDULE', handleCancelCampaign);
  // AI template generation
  yield takeLatest('GENERATE_AI_TEMPLATE', handleGenerateAITemplate);
}
